import { HorizontalSelectOption } from '@/shared/components/FormInputs/HorizontalSelect/types';

import CallCancelSvg from '@/assets/svgs/call-cancel.svg';
import UsersP2PSvg from '@/assets/svgs/users-p2p.svg';
// import CircleRecordSvg from '@/assets/svgs/circle-record.svg';
import TestTubeSvg from '@/assets/svgs/test-tube.svg';

import AuxDataSvg from '@/assets/svgs/contact-lists/icon_aux_data.svg';
import EmailSvg from '@/assets/svgs/contact-lists/icon_email.svg';
import ExternalSvg from '@/assets/svgs/contact-lists/icon_external.svg';
import LinesSvg from '@/assets/svgs/contact-lists/icon_lines.svg';
import LocationSvg from '@/assets/svgs/contact-lists/icon_location.svg';
import PersonSvg from '@/assets/svgs/contact-lists/icon_person.svg';
import TitleSvg from '@/assets/svgs/contact-lists/icon_title.svg';

import {
  ContactListType,
  FieldData,
  OptionalFeatureSchema,
} from '@/containers/ContactLists/types';

export const listTypeOptions: HorizontalSelectOption[] = [
  {
    icon: <UsersP2PSvg />,
    label: 'P2P SMS',
    value: 'p2p-sms' as ContactListType,
  },
  // {
  //   icon: <CircleRecordSvg />,
  //   label: 'IVR',
  //   value: 'ivr' as ContactListType,
  // },
  {
    icon: <TestTubeSvg className="h-5 w-5" />,
    label: 'Test',
    value: 'test' as ContactListType,
  },
  {
    icon: <CallCancelSvg />,
    label: 'Suppression',
    value: 'suppression' as ContactListType,
  },
];

export const ContactListTypeMapping = {
  P2PSms: 4,
  SuppressionList: 5,
  Test: 6,
};

export const ContactListTypeNameMapping = {
  4: 'P2P SMS',
  5: 'Suppression List',
  6: 'Test',
};

export const optionalFeaturesList: Record<ContactListType, OptionalFeatureSchema[]> = {
  'p2p-sms': [
    {
      label: 'Split States',
      key: 'split_states',
    },
    {
      label: 'NDNC Scrub',
      key: 'use_nat_dnc',
    },
    // {
    //   label: 'Scrub Against Florida DNC',
    //   key: 'use_state_dnc',
    // },
  ],
  // ivr: [
  //   {
  //     label: 'Split States',
  //     key: 'split_states',
  //   },
  //   {
  //     label: 'NDNC Scrub',
  //     key: 'use_nat_dnc',
  //   },
  //   {
  //     label: 'Suppress Cell',
  //     key: 'suppress_cell_phones',
  //   },
  // ],
  suppression: [
    {
      label: 'Split States',
      key: 'split_states',
    },
  ],
  test: [],
};

export const showNumberOfItemsInColumnMapping = 5;

export const mappingFields: FieldData[] = [
  {
    icon: <ExternalSvg />,
    title: 'External ID',
    name: 'extern_id',
  },
  {
    icon: <PersonSvg />,
    title: 'First name',
    name: 'first_name',
  },
  {
    icon: <TitleSvg />,
    title: 'Title',
    name: 'title',
  },
  {
    icon: <PersonSvg />,
    title: 'Middle name',
    name: 'mid_name',
  },
  {
    icon: <PersonSvg />,
    title: 'Last name',
    name: 'last_name',
  },
  {
    icon: <LinesSvg />,
    title: 'Suffix',
    name: 'suffix',
  },
  {
    icon: <LocationSvg />,
    title: 'Address 1',
    name: 'address1',
  },
  {
    icon: <LocationSvg />,
    title: 'Address 2',
    name: 'address2',
  },
  {
    icon: <LocationSvg />,
    title: 'City',
    name: 'city',
  },
  {
    icon: <LocationSvg />,
    title: 'State',
    name: 'state',
  },
  {
    icon: <LocationSvg />,
    title: 'Zip',
    name: 'zip',
  },
  {
    icon: <EmailSvg />,
    title: 'Email',
    name: 'email',
  },
  {
    icon: <AuxDataSvg />,
    title: 'Aux data 1',
    name: 'aux_data1',
  },
  {
    icon: <AuxDataSvg />,
    title: 'Aux data 2',
    name: 'aux_data2',
  },
  {
    icon: <AuxDataSvg />,
    title: 'Aux data 3',
    name: 'aux_data3',
  },
  {
    icon: <AuxDataSvg />,
    title: 'Aux data 4',
    name: 'aux_data4',
  },
  {
    icon: <AuxDataSvg />,
    title: 'Aux data 5',
    name: 'aux_data5',
  },
];
